// extracted by mini-css-extract-plugin
export default {"container":"Login_container__+Ihqx","btn-atmos":"Login_btn-atmos__dDEir","atmosColor":"Login_atmosColor__vOXwC","button24":"Login_button24__tJVu+"};